import React from 'react';
import DropdownMenuItem from '../shared/dropdownMenu/DropdownMenuItem';
import permissions from '../../permissionsList';
import AccessControl from '../../AccessControl';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import DropdownMenu from '../shared/dropdownMenu/DropdownMenu';
import {
  associateAlertDeviceText,
  associateAlarmDeviceText,
} from '../shared/SharedInternationalizations';

function UserQuickActionsMenu(props) {
  const { currentLocation, user } = props;
  const { id, is_active, preferences } = user;

  const viewUserText = (
    <FormattedMessage
      id="userQuickActionsMenu.viewUserText"
      defaultMessage="View User"
      description="Opens editing something"
    />
  );
  const editUserText = (
    <FormattedMessage
      id="userQuickActionsMenu.editUserText"
      defaultMessage="Edit User"
      description="Opens editing something"
    />
  );

  const quickEditUnitsText = (
    <FormattedMessage
      id="userQuickActionsMenu.quickEditUnitsText"
      defaultMessage="Quick Edit Units"
      description="A link to open the interface to edit the units assigned to this user"
    />
  );
  const updatePasswordText = (
    <FormattedMessage
      id="userQuickActionsMenu.updatePasswordText"
      defaultMessage="Update Password"
      description="A link to open the interface to update the password for this user"
    />
  );

  return (
    <DropdownMenu data-test="quick-actions-menu" buttonStyles="margin-5">
      <DropdownMenuItem data-test="">
        <Link
          data-test="full-view-quick-actions-link"
          className="dropdown-menu__menu-content-item"
          to={`${id}/view`}
          state={{
            previous: currentLocation,
          }}>
          {viewUserText}
        </Link>
      </DropdownMenuItem>
      <AccessControl
        data-test="access-control"
        feature={permissions.static.users.editUser}
        userToEdit={id}>
        <DropdownMenuItem
          additionalStyles={
            is_active ? '' : 'dropdown-menu__menu-item--inactive'
          }>
          <Link
            data-test="edit-link"
            className={
              is_active
                ? 'dropdown-menu__menu-content-item'
                : 'dropdown-menu__menu-content-item--inactive'
            }
            to={`/users/${id}/edit`}
            state={{
              modal: true,
              previous: currentLocation,
            }}>
            {editUserText}
          </Link>
        </DropdownMenuItem>
      </AccessControl>
      <AccessControl
        data-test="access-control"
        feature={permissions.static.users.editUser}
        userToEdit={id}>
        {preferences ? (
          <DropdownMenuItem
            additionalStyles={
              is_active ? '' : 'dropdown-menu__menu-item--inactive'
            }>
            <Link
              data-test="update-password-link"
              className={
                is_active
                  ? 'dropdown-menu__menu-content-item'
                  : 'dropdown-menu__menu-content-item--inactive'
              }
              to={`${id}/updatePassword`}
              state={{
                modal: true,
                previous: currentLocation,
              }}>
              {updatePasswordText}
            </Link>
          </DropdownMenuItem>
        ) : (
          ''
        )}
      </AccessControl>

      <AccessControl
        data-test="access-control"
        feature={permissions.static.users.editUser}
        userToEdit={id}>
        <DropdownMenuItem
          additionalStyles={
            is_active ? '' : 'dropdown-menu__menu-item--inactive'
          }>
          <Link
            data-test="associate-units-to-user-link"
            className={
              is_active
                ? 'dropdown-menu__menu-content-item'
                : 'dropdown-menu__menu-content-item--inactive'
            }
            to={`/users/${id}/edit?mode=associateUnits`}
            state={{
              modal: true,
              previous: currentLocation,
            }}>
            {quickEditUnitsText}
          </Link>
        </DropdownMenuItem>
      </AccessControl>
      <AccessControl
        data-test="access-control"
        feature={permissions.static.devices.addDeviceAssociation}>
        <DropdownMenuItem
          additionalStyles={
            is_active ? '' : 'dropdown-menu__menu-item--inactive'
          }>
          <Link
            data-test="associate-alarm-device-link"
            className={
              is_active
                ? 'dropdown-menu__menu-content-item'
                : 'dropdown-menu__menu-content-item--inactive'
            }
            to={`/users/${id}/edit?mode=associateAlarmDevice`}
            state={{
              modal: true,
              previous: currentLocation,
            }}>
            {associateAlarmDeviceText}
          </Link>
        </DropdownMenuItem>
      </AccessControl>

      <AccessControl
        data-test="access-control"
        feature={permissions.static.devices.addDeviceAssociation}>
        <DropdownMenuItem
          additionalStyles={
            is_active ? '' : 'dropdown-menu__menu-item--inactive'
          }>
          <Link
            data-test="associate-alert-device-link"
            className={
              is_active
                ? 'dropdown-menu__menu-content-item'
                : 'dropdown-menu__menu-content-item--inactive'
            }
            to={`/users/${id}/edit?mode=associateAlertDevice`}
            state={{
              modal: true,
              previous: currentLocation,
            }}>
            {associateAlertDeviceText}
          </Link>
        </DropdownMenuItem>
      </AccessControl>
      <AccessControl
        data-test="access-control"
        feature={permissions.static.devices.addDeviceAssociation}>
        <DropdownMenuItem
          data-test="swap-fixed-device-link"
          additionalStyles={
            is_active ? '' : 'dropdown-menu__menu-item--inactive'
          }>
          <a
            data-test="swap-device-link"
            className={
              is_active
                ? 'dropdown-menu__menu-content-item'
                : 'dropdown-menu__menu-content-item--inactive'
            }
            href="/utils/device_swap.php">
            <FormattedMessage
              id="userCard.swapFixedDeviceText"
              defaultMessage="Swap a Fixed Device"
              description="The user phone number"
            />
          </a>
        </DropdownMenuItem>
      </AccessControl>
      <AccessControl
        data-test="access-control"
        feature={permissions.static.devices.addDeviceAssociation}>
        <DropdownMenuItem
          data-test="swap-pendant-link"
          additionalStyles={
            is_active ? '' : 'dropdown-menu__menu-item--inactive'
          }>
          <a
            data-test="swap-pendant-link"
            className={
              is_active
                ? 'dropdown-menu__menu-content-item'
                : 'dropdown-menu__menu-content-item--inactive'
            }
            href="/utils/pendant_swap.php">
            <FormattedMessage
              id="userCard.swapPendantText"
              defaultMessage="Swap a Pendant"
              description="The user phone number"
            />
          </a>
        </DropdownMenuItem>
      </AccessControl>
    </DropdownMenu>
  );
}

export default UserQuickActionsMenu;
